import {
  DashboardRoundIcon,
  DashboardOutlinedIcon,
  RoomsOutlinedIcon,
  AccountBalanceOutline,
  AccountBalanceRound,
  CreditCardOffOutline,
  CreditCardOffRound,
  TenantsOutlinedIcon,
  TenantsRoundIcon,
  StorefrontIconOutlined,
  StorefrontIconRound,
  QuickReferenceAllIcon,
  MoneyBagIcon,
  RoomPreferencesIconOutlined,
  RoomPreferencesIconRound,
} from "@/assets/icons";
import { translate } from "@/utils";
import type { INavbarItem } from "@/components/Base/NavItem.vue";

const translator = (key: string, parentKey?: string | null) => {
  if (parentKey) {
    return translate(`navigationSubItems.${parentKey}.${key}`) as string;
  } else {
    return translate(`navigationItems.${key}`) as string;
  }
};

export const navigationData: INavbarItem[] = [
  {
    title: "Anasayfa",
    icon: DashboardOutlinedIcon,
    selectedIcon: DashboardRoundIcon,
    subItems: [],
    selected: false,
    routeKey: "dashboard",
    link: "/anasayfa",
  },
  {
    title: translator("banks"),
    icon: AccountBalanceOutline,
    selectedIcon: AccountBalanceRound,
    subItems: [],
    selected: false,
    link: "/kasalar",
    routeKey: "banks",
  },
  {
    title: translator("rooms"),
    icon: RoomsOutlinedIcon,
    selectedIcon: RoomsOutlinedIcon,
    subItems: [],
    selected: false,
    link: "/magazalar",
    routeKey: "PropertiesView",
  },
  {
    title: "Depolar",
    icon: StorefrontIconOutlined,
    selectedIcon: StorefrontIconRound,
    subItems: [],
    selected: false,
    link: "/depolar",
    routeKey: "StoresView",
  },
  {
    title: "Yönetim",
    icon: RoomPreferencesIconOutlined,
    selectedIcon: RoomPreferencesIconRound,
    subItems: [],
    selected: false,
    link: "/yonetim",
    routeKey: "TenantRentsView",
  },
  {
    title: "Kişiler",
    icon: TenantsOutlinedIcon,
    selectedIcon: TenantsRoundIcon,
    subItems: [],
    selected: false,
    link: "/kisiler",
    routeKey: "TenantsView",
  },
  {
    title: translator("expenses"),
    icon: CreditCardOffOutline,
    selectedIcon: CreditCardOffRound,
    subItems: [],
    selected: false,
    link: "/giderler",
    routeKey: "ExpenseView",
  },
  {
    title: "Gelirler",
    icon: MoneyBagIcon,
    selectedIcon: MoneyBagIcon,
    subItems: [],
    selected: false,
    link: "/gelirler",
    routeKey: "RevenueView",
  },
  {
    title: "Raporlar",
    icon: QuickReferenceAllIcon,
    selectedIcon: QuickReferenceAllIcon,
    subItems: [
      {
        title: "Genel",
        subItems: [],
        selected: false,
        link: "/genel",
        routeKey: "ReportsView",
      },
      {
        title: "Kişi Bazlı",
        subItems: [],
        selected: false,
        link: "/kisiler",
        routeKey: "ReportTenantsView",
      },
      {
        title: "Kasalar",
        subItems: [],
        selected: false,
        link: "/kasalar",
        routeKey: "ReportBanksView",
      },
      {
        title: "Giderler",
        subItems: [],
        selected: false,
        link: "/giderler",
        routeKey: "ReportExpensesView",
      },
      {
        title: "Gelirler",
        subItems: [],
        selected: false,
        link: "/gelirler",
        routeKey: "ReportRevenuesView",
      },
      {
        title: "Ayrılan Kiracılar",
        subItems: [],
        selected: false,
        link: "/ayrilan-kiracilar",
        routeKey: "ReportFormerTenantsView",
      },
    ],
    selected: false,
    link: "/raporlar",
  },
];
